<template>
  <div>
    <p>Logging out ...</p>
  </div>
</template>

<script>
export default {
  methods: {
    async logout() {
      await this.$store.dispatch("logout").then(() => this.$router.push("/"));
    },
  },
  mounted() {
    this.logout();
  },
};
</script>
